export const environment = {
    production: true,
    staging: false,
    apiUrl: '',
    recaptcha: {
        siteKey: '6Lc3OwwqAAAAAA_EQHA5tLW-JF7-eQlIgTTiSie4'
    },
};
